import Section from 'components/common/Section'
import { SectionHeader } from 'components/marketing/SectionHeader'
import ExternalIcon from 'icons/ExternalIcon'
import { ComponentGraphiQlOverlappingBackground } from 'types/generated/contentful'
import { useThemeColor } from './ThemeContext'
import dynamic from 'next/dynamic'

// GraphiQL tries to access localStorage and breaks server rendering,
// so we need force GraphiQL to render only on the client
const GraphiQL = dynamic(() => import('components/GraphiQL'), {
  ssr: false,
})

export const GraphiQlOverlappingBackground = ({
  label,
  headline,
  subheadline,
  linkLabel,
  linkUrl,
  graphiQl,
}: ComponentGraphiQlOverlappingBackground): JSX.Element => {
  const themeColor = useThemeColor()

  return (
    <Section bgColor='darkgray' relative>
      <div className='hidden absolute inset-x-0 bottom-0 h-1/3 bg-white lg:block' />

      <SectionHeader
        label={label!}
        title={headline!}
        subline={subheadline!}
        highlight={themeColor}
        theme='dark'
      />

      {linkLabel && (
        <div className='-mt-12 mb-10 sm:flex sm:justify-center lg:-mt-24 lg:mb-14'>
          <a
            href={linkUrl!}
            target='_blank'
            rel='noopener noreferrer'
            className='inline-flex items-center gap-2 text-18 font-demibold text-neutral-on-dark-80 hover:text-neutral-on-dark'
          >
            {linkLabel}
            <ExternalIcon />
          </a>
        </div>
      )}

      <div className='hidden relative lg:block lg:-mx-20 xl:-mx-10'>
        <GraphiQL
          storageKeyPrefix={null}
          endpoint={graphiQl!.graphQlEndpoint!}
          defaultQuery={graphiQl!.defaultQuery!}
          className='h-[640px] bg-gray-100 rounded-6'
        />
      </div>
    </Section>
  )
}
